/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Creates URL for links.
 * @param  {string} context
 * @param  {string} slug1
 * @param  {string} slug2
 * @return {string}
 */
export const createUrl = (context, slug1, slug2 = null) => {
  switch (context) {
    case 'home':
      return '/';

    case 'terms':
      return '/terms';

    case 'login':
      return '/login';

    case 'passwordReset':
      return '/login/password-reset';

    case 'signup':
      return '/signup';

    case 'account':
      return '/account';

    case 'invite':
      return '/invite';

    case 'inviteColleague':
      return '/invite/colleague';

    case 'viewInvite':
      return `/invite/${slug1}`;

    case 'pageAdmin':
      return '/page/admin';

    case 'editProfile':
      return '/account/profile';

    case 'editPortfolio':
      return '/account/portfolio';

    case 'editCompany':
      return '/account/company';

    case 'payments':
      return '/account/payments';

    case 'previewCompany':
      return `/account/company/${slug1}`;

    case 'previewProfile':
      return `/account/profile/${slug1}`;

    case 'updatePhone':
      return '/account/phone/update';

    case 'verifyPhoneNumber':
      return '/account/phone/verify';

    case 'admin':
      return '/account/admin';

    case 'inbox':
      return '/account/inbox';

    case 'message':
      return `/account/inbox/${slug1}`;

    case 'profile':
      return `/profile/${slug1}`;

    case 'company':
      return `/company/${slug1}`;

    case 'jobs':
      return '/account/jobs';

    case 'jobEdit':
      return `/account/jobs/edit/${slug1}`;

    case 'updateOffer':
      return `/account/jobs/offer/${slug1}`;

    case 'jobSendRequests':
      return '/requests/submit/';

    case 'job':
      return `/account/jobs/view/${slug1}`;

    case 'jobFavorites':
      return `/jobs/view/${slug1}/favorites`;

    case 'jobRequests':
      return `/jobs/view/${slug1}/requests`;

    case 'jobRequestTalent':
      return `/jobs/view/${slug1}/request/${slug2}`;

    case 'jobHires':
      return `/jobs/view/${slug1}/hires`;

    case 'jobMoodboard':
      return `/jobs/view/${slug1}/moodboard`;

    case 'jobMessage':
      return `/jobs/view/${slug1}/inbox/${slug2}`;

    case 'jobTalent':
      return `/jobs/view/${slug1}/talent/${slug2}`;

    case 'createJob':
      return '/jobs/create';

    case 'addTalent':
      return `/jobs/edit/${slug1}/talent/add`;

    case 'request':
      return `/jobs/request/${slug1}`;

    case 'save':
      return `/jobs/save/${slug1}`;

    case 'talents':
      return '/talents';

    case 'textPage':
      return `/page/${slug1}`;

    case 'removeTalent':
      return `/jobs/view/${slug1}`;

    case 'news':
      return '/news';

    case 'blogPost':
      return `/news/${slug1}`;

    case 'blogCategory':
      return `/news/category/${slug1}`;

    case 'shortlist':
      return `/talents/${slug1}`;

    case 'createShortlist':
      return `/shortlist/create`;

    case 'likes':
      return `/likes/${slug1}`;

    default:
      return `/${slug1}`;
  }
};

// Check if URL is external.
export const isExternal = path => /^https?:\/\//.test(path);
